<template>
  <layout-main-inner title="日志查看">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <el-input
          v-model="config.userName"
          placeholder="请输入操作人员姓名"
          clearable=""
          style="width: 240px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="请求内容"
          :resizable="false"
          min-width="240">
          <template slot-scope="{row}">
            <div>
              <span style="color:#000">请求参数：</span>
              <div>
                <pre style="line-height: 20px;margin: 6px 0">{{ row.reqMsg }}</pre>
              </div>
            </div>
            <div>
              <span style="color:#000">请求时间：</span>
              <div>{{ row.reqTime | dateformat() }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="响应内容"
          :resizable="false"
          min-width="380">
          <template slot-scope="{row}">
            <div>
              <span style="color:#000">响应数据：</span>
              <div>
                <pre style="line-height: 16px;margin: 0">{{ row.respMsg }}</pre>
              </div>
            </div>
            <div>
              <span style="color:#000">响应时间：</span>
              <div>{{ row.respTime | dateformat() }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作信息"
          :resizable="false"
          width="150"
          prop="operationDesc">
          <template slot-scope="{row}">
            <div>
              <span style="color:#000">模块：</span>
              <span>{{ row.operationDesc }}</span>
            </div>
            <div>
              <span style="color:#000">动作：</span>
              <span>{{ row.operation }}</span>
            </div>
            <div>
              <span style="color:#000">人员：</span>
              <span>{{ row.userName }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="动作"
          :resizable="false"
          width="70"
          prop="operation">
        </el-table-column>
        <el-table-column
          label="操作人员"
          :resizable="false"
          width="80"
          prop="userName">
        </el-table-column> -->
        <!-- <el-table-column
          label="创建时间"
          :resizable="false"
          width="130">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column> -->
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LooseTeaList',
  components: { },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        userName: '',
        operations: ['add', 'delete', 'update', 'login', 'logout', 'other']
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query,
      userDetail: state => state.account.userDetail
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('common/getaudits', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            let reqMsg = null
            let respMsg = null
            try {
              reqMsg = JSON.stringify(JSON.parse(i.reqMsg), null, 2)
              respMsg = JSON.stringify(JSON.parse(i.respMsg), null, 2)
            } catch (error) {
              reqMsg = i.reqMsg
              respMsg = i.respMsg
            }
            return {
              ...i,
              reqMsg,
              respMsg
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
